export function checkIfHasInvestorAccess() {
    if (typeof window === "undefined") return false;
  
    const queryPw = new URLSearchParams(window.location.search).get("for");
  
    if (queryPw && queryPw.trim()) {
      return true;
    }
  
    return document.cookie
      .split(";")
      .map((c) => c.trim())
      .some((c) => c === "BA_HAS_SESSION=1");
  }